import React, { useState } from "react";
import { Link } from "react-router-dom"
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import FacebookIcon from "../images/facebook.png"
import TwitterIcon from "../images/twitter.png"
import InstagramIcon from "../images/instagram.png"
import HerdLink from "../images/herdlink.jpg"

import Container from "./container"

import colors from "../settings/colors"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Menu = styled.nav`
    position: ${isMobile ? "absolute":"sticky"};
    top: 0px;
    width: ${isMobile ? "100vw":"100%"};

    background-color: ${colors.darkgrey};
    z-index: 99;
    
    > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 50px;

        ul {
            display: flex;
            flex-flow: ${isMobile ? "column":"unset"};

            &.open {
                li {
                    display: block;
                }
            }

            list-style-type: none;
            margin: 0px;
            padding: 0px;

            li {
                display: none;
                width: ${isMobile ? "100vw":"unset"};

                a {
                    display: block;
                    padding: 10px 20px;
                    height: 50px;
                    line-height: 30px;
                    white-space: nowrap;
        
                    color: white;
                    text-decoration: none;

                    &:hover {
                        background-color: ${colors.darkgreyHover};
                    }
                }

                &.menu, &.social {
                    display: ${isMobile ? "unset":"none"};
                }
                &.social {
                    width: auto !important;
                }
                &.active {
                    a {
                        background-color: black;
                    }
                }
            }

            &.social {
                position: ${isMobile ? "absolute":"unset"};
                right: 0px;
                top: 0px;
                flex-flow: row;

                li {
                    display: block !important;
                    
                    a {
                        padding: ${isMobile ? "10px 3px":"10px"};
                    }
                }
            }
        }
    }
`

function TopMenu(props) {
  const [open, setOpen] = useState(!isMobile);

  const items = [
    {name: "home", url: "/", title: "Shows"},
    // {name: "masters", url: "/speaker-series", title: "Speaker Series"},
    // {name: "sponsors", url: "/sponsors", title: "Sponsors"},
    {name: "philharmonic", url: "/philharmonic", title: "Philharmonic Club"},
    {name: "students", url: "/students", title: "Students"},
    {name: "covid", url: "/covid", title: "Covid-19"},
    {name: "faq", url: "/faq", title: "FAQ"},
    {name: "subscribe", url: "/subscribe", title: "Subscribe"},
    {name: "contact", url: "/contact", title: "Contact"},
  ]

  function onMenu(e) {
    e.preventDefault();
    setOpen(!open);
  }

  return (
    <Menu>    
        <Container nopadding={true}>
            <ul className={open ? "open":""}>
                <li className="menu">
                    <a href="#" onClick={onMenu}>
                    <FontAwesomeIcon icon={faBars} />
                    </a>
                </li>

                {items.map((item, index) => (
                    <li key={index} className={item.name === props.page ? "active" : ""}>
                        <Link to={item.url}>
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>

            <ul className="social">
                <li className="social">
                    <a href="http://www.facebook.com/pages/Marshall-Artists-Series/133479037639" target="_blank" rel="noreferrer">
                        <img src={FacebookIcon} width="32" height="32" border="0" alt="Facebook" /></a>
                </li>
                <li className="social">
                    <a href="https://www.instagram.com/muartistsseries/?hl=en" target="_blank" rel="noreferrer">
                        <img src={InstagramIcon} width="30" height="30" border="0" alt="Instagram" /></a>
                </li>                
                {/* <li className="social">
                    <a href="http://twitter.com/muartistsseries" target="_blank" rel="noreferrer">
                        <img src={TwitterIcon} width="32" height="32" border="0" alt="Twitter" /></a>
                </li> */}
                <li className="social">
                    <a href="https://herdlink.marshall.edu/organization/mas" target="_blank" rel="noreferrer">
                        <img src={HerdLink} height="32" border="0" alt="Herd Link" /></a>
                </li>
            </ul>
        </Container>
      </Menu>
  );
}

export default TopMenu;